import { client, gql } from './Client';

const userRoleQuery = gql`
  query currentUserDetails {
    currentUserDetails {
      name
      roles
      id
      email
    }
  }
`;

const userRole = () => client.query({ query: userRoleQuery });

export { userRole };
